var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-left w-full flex flex-col address-modal-container"
  }, [_c('div', {
    staticClass: "flex items-center gap-4 mb-6 mdmax:mb-4"
  }, [_c('span', {
    staticClass: "cursor-pointer hidden mdmax:block",
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15 18L9 12L15 6",
      "stroke": "#2D3748",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])]), _c('p', {
    staticClass: "text-2xl font-bold mdmax:text-xl mdmax:text-center mdmax:flex-1 mdmax:-ml-8"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "overflow-y-auto flex-1 pr-2 -mr-2 pb-4"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_vm._m(0), _c('div', {
    staticClass: "mb-4 relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": "Cari alamat tersimpan..."
    },
    model: {
      value: _vm.savedAddressSearchKeyword,
      callback: function callback($$v) {
        _vm.savedAddressSearchKeyword = $$v;
      },
      expression: "savedAddressSearchKeyword"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 cursor-pointer pointer-events-none"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16z",
      "stroke": "#A0AEC0",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M19 19l-4.35-4.35",
      "stroke": "#A0AEC0",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])], 1), _c('div', {
    staticClass: "flex overflow-x-auto gap-4 pb-2 snap-x hide-scrollbar"
  }, [_vm._l(_vm.filteredAddresses, function (addr, index) {
    return _c('div', {
      key: 'saved-addr-' + index,
      staticClass: "flex-shrink-0 w-56 p-4 border-2 rounded-xl cursor-pointer snap-start transition-all",
      class: _vm.selectedAddressId === addr.id ? 'border-primary-500 bg-primary-50 shadow-sm' : 'border-neutral-300 hover:border-primary-400 bg-white',
      on: {
        "click": function click($event) {
          return _vm.selectSavedAddress(addr);
        }
      }
    }, [_c('p', {
      staticClass: "text-xs text-neutral-500 mb-1"
    }, [_vm._v(_vm._s(addr.location_label || 'Label Alamat'))]), _c('p', {
      staticClass: "font-bold text-neutral-800 mb-1 truncate"
    }, [_vm._v(_vm._s(addr.sender_name || addr.receiver_name || addr.name))]), _c('p', {
      staticClass: "text-xs text-neutral-600 line-clamp-2 leading-tight mb-1"
    }, [_vm._v(_vm._s(addr.address))]), _c('p', {
      staticClass: "text-xs text-neutral-500 truncate"
    }, [_vm._v(_vm._s(addr.area ? addr.area.village + ', ' + addr.area.area_display : ''))])]);
  }), !_vm.filteredAddresses || _vm.filteredAddresses.length === 0 ? _c('div', {
    staticClass: "text-sm text-neutral-500 py-4 w-full text-center border border-dashed border-neutral-300 rounded-xl"
  }, [_vm._v(" Belum ada alamat tersimpan ")]) : _vm._e()], 2)]), _c('div', {
    staticClass: "p-5 bg-white rounded-xl border border-neutral-100 shadow-sm"
  }, [_c('p', {
    staticClass: "font-bold text-neutral-800 mb-4"
  }, [_vm._v(_vm._s(_vm.formTitle))]), _c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Label *",
      "placeholder": "Contoh: Rumah"
    },
    model: {
      value: _vm.form.label,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "label", $$v);
      },
      expression: "form.label"
    }
  })], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama *",
      "placeholder": "Contoh: Linknau"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No. Handphone *",
      "placeholder": "08123456789"
    },
    on: {
      "keypress": _vm.numbersOnly,
      "input": _vm.validatePhoneNumber,
      "blur": _vm.onPhoneBlur
    },
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1), _c('div', {
    staticClass: "mb-4 relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Area *")]), _c('div', {
    staticClass: "w-full border rounded-lg p-3 pr-10 cursor-pointer flex items-center justify-between",
    class: [_vm.visibleSuggestion ? 'border-primary-500 ring-1 ring-primary-500' : 'border-neutral-300', _vm.form.area ? 'bg-primary-50 border-primary-500' : 'bg-white'],
    on: {
      "click": _vm.toggleAreaDropdown
    }
  }, [_vm.form.area ? _c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-sm"
  }, [_vm._v(_vm._s(_vm.form.area.village))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s(_vm.form.area.area_display))])]) : _c('div', {
    staticClass: "text-neutral-400 text-sm"
  }, [_vm._v(" Pilih area... ")]), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "stroke": "#A0AEC0",
      "stroke-width": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 7.5L10 12.5L15 7.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])]), _vm.visibleSuggestion ? _c('div', {
    staticClass: "fixed inset-0 z-10",
    on: {
      "click": function click($event) {
        _vm.visibleSuggestion = false;
      }
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion ? _c('div', {
    staticClass: "mt-1 z-20 border rounded-lg absolute top-full left-0 w-full bg-white shadow-lg overflow-hidden flex flex-col"
  }, [_c('div', {
    staticClass: "p-3 border-b border-neutral-100 relative"
  }, [_c('div', {
    staticClass: "relative flex items-center"
  }, [_c('div', {
    staticClass: "absolute left-3 text-neutral-400"
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16z"
    }
  }), _c('path', {
    attrs: {
      "d": "M19 19l-4.35-4.35"
    }
  })])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.citySearch,
      expression: "citySearch"
    }],
    ref: "areaSearchInput",
    staticClass: "w-full bg-neutral-50 border border-neutral-200 rounded-lg py-2 pl-10 pr-10 text-sm focus:outline-none focus:border-primary-500 transition-colors",
    attrs: {
      "type": "text",
      "placeholder": "Cari area..."
    },
    domProps: {
      "value": _vm.citySearch
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.citySearch = $event.target.value;
      }, _vm.searchCity]
    }
  }), _vm.isSearchingCity ? _c('img', {
    staticClass: "w-5 absolute right-3",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e()])]), _c('ul', {
    staticClass: "max-h-56 overflow-y-auto"
  }, [_vm.form.area && _vm.matchesSearch(_vm.form.area) ? _c('li', {
    staticClass: "cursor-pointer px-4 py-3 border-b border-neutral-100 flex items-center justify-between bg-white hover:bg-neutral-50",
    on: {
      "click": function click($event) {
        return _vm.selectCity(_vm.form.area);
      }
    }
  }, [_c('div', [_c('p', {
    staticClass: "font-bold text-neutral-800 text-sm"
  }, [_vm._v(_vm._s(_vm.form.area.village))]), _c('p', {
    staticClass: "text-xs text-neutral-500"
  }, [_vm._v(_vm._s(_vm.form.area.area_display))])]), _c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#10B981",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])]) : _vm._e(), _vm._l(_vm.filteredCitiesList, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-4 py-3 border-b border-neutral-100 last:border-b-0 hover:bg-neutral-50 transition-colors",
      on: {
        "click": function click($event) {
          return _vm.selectCity(city);
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "font-bold text-neutral-800 text-sm"
    }, [_vm._v(_vm._s(city.village))]), _c('p', {
      staticClass: "text-xs text-neutral-500"
    }, [_vm._v(_vm._s(city.area_display))])])]);
  }), !_vm.isSearchingCity && _vm.filteredCitiesList.length === 0 && (!_vm.form.area || !_vm.matchesSearch(_vm.form.area)) ? _c('li', {
    staticClass: "text-center py-6 text-neutral-500 text-sm"
  }, [_vm._v(" Area tidak ditemukan ")]) : _vm._e()], 2)]) : _vm._e()])], 1), _c('div', {
    staticClass: "mb-4"
  }, [_c('Textarea', {
    attrs: {
      "label": "Alamat *",
      "placeholder": "Tulis alamat"
    },
    model: {
      value: _vm.form.address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1), _c('div', {
    staticClass: "flex items-center gap-2 mb-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.saveAddress,
      expression: "form.saveAddress"
    }],
    staticClass: "w-4 h-4 rounded border-neutral-300 text-primary-500 focus:ring-primary-500 cursor-pointer",
    attrs: {
      "type": "checkbox",
      "id": "saveAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.saveAddress) ? _vm._i(_vm.form.saveAddress, null) > -1 : _vm.form.saveAddress
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.saveAddress,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "saveAddress", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "saveAddress", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "saveAddress", $$c);
        }
      }
    }
  }), _c('label', {
    staticClass: "text-sm font-medium text-neutral-700 cursor-pointer",
    attrs: {
      "for": "saveAddress"
    }
  }, [_vm._v("Simpan Alamat")])])])]), _c('div', {
    staticClass: "mt-auto pt-4 border-t border-neutral-100 bg-white z-10"
  }, [_c('Button', {
    staticClass: "w-full",
    attrs: {
      "buttonText": "Gunakan Alamat Ini",
      "type": "primary",
      "disabled": _vm.isDisabled || _vm.isSaving,
      "isLoading": _vm.isSaving
    },
    on: {
      "action": function action($event) {
        return _vm.applyAddress();
      }
    }
  })], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('p', {
    staticClass: "font-bold text-neutral-800"
  }, [_vm._v("Alamat Tersimpan")])]);
}]

export { render, staticRenderFns }